import React from 'react';
import OwlCarousel from "react-owl-carousel3";
import {Link} from 'react-router-dom';
const OwlCarouselElementsSliders  = (props) => {		
	const options = {
	 	loop:true,
		margin:30,
		nav:true,
		dots: false,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
		responsive:{
			0:{
				items:1
			},
			
			480:{
				items:2
			},			
			
			767:{
				items:3
			},
			1000:{
				items:3
			}
		}
    };	
	const options1 = {
	 	loop:true,
		margin:0,
		nav:true,
		dots: true,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
		responsive:{
			0:{
				items:1
			},
			
			480:{
				items:1
			},			
			
			767:{
				items:1
			},
			1000:{
				items:1
			}
		}
    };
    return(
	<>
	{/* <!-- GALLERY SECTION START --> */}
	 {(props.type==='FadeSlider')?
		<OwlCarousel className="owl-fade-slider-one owl-btn-vertical-center owl-dots-bottom-right" {...options1}>
			{props.data.map((item, index) => (							
				<div className="item" key={item.id}>
					<div className="aon-thum-bx">
						<img src={item.image} alt={item.alt} className="" />
					</div>
					<div className="ow-event-title">
						<h4 className="event-title"><Link to="/services-1" title="Video post">{item.title}</Link></h4>
					</div>
				</div>																						  
			))}	
			
		</OwlCarousel>
	:(props.type==='SlideSlider')?
		<OwlCarousel className="owl-fade-slider-one owl-btn-vertical-center owl-dots-bottom-right" {...options1}>
			{props.data.map((item, index) => (							
				<div className="item" key={item.id}>
					<div className="aon-thum-bx">
						<img src={item.image} alt={item.alt} className="" stye={{height:"auto"}} />
					</div>
					
				</div>																						  
			))}	
			
		</OwlCarousel>
	:(props.type==='EventSlider')?
	<OwlCarousel className="owl-carousel blog-carousel  owl-btn-vertical-center" {...options}>
		{props.data.map((item, index) => (							
			
			<div className="item" key={item.id}>
				<div className="ow-event-post date-style-2">
					<div className="ow-event-media wt-img-effect zoom-slow">							
						<img src={item.image} alt={item.alt} className="" />
					</div>
					<div className="ow-event-info p-a30 bg-gray">
						<div className="ow-event-title">
							<h4 className="event-title"><Link to="/services-1" title="Video post">{item.title}</Link></h4>
						</div>
						
						<div className="ow-event-text">
							<p>{item.description}</p>
						</div>
						<div className="clearfix">
							<div className="ow-event-readmore pull-left"> 
								<Link to={`/${item.link}`} title="READ MORE" rel="bookmark" className=" site-button-link">Read More</Link>
							</div>
							<div className="widget_social_inks pull-right">
									<ul className="social-icons social-radius social-dark m-b0">											
										<li><Link to={`https://www.facebook.com/${process.env.REACT_APP_FACEBOOK_USERNAME}`} className="fa fa-facebook"></Link></li>
										<li><Link to={`https://twitter.com/${process.env.REACT_APP_TWITTER_USERNAME}`} className="fa fa-twitter"></Link></li>
										<li><Link to={`https://in.linkedin.com/${process.env.REACT_APP_LINKEDIN_USERNAME}`} className="fa fa-linkedin"></Link></li>						
										<li><Link to={`https://www.youtube.com/${process.env.REACT_APP_YOUTUBE_USERNAME}`} className="fa fa-youtube"></Link></li>
										<li><Link to={`https://www.instagram.com/${process.env.REACT_APP_INSTAGRAM_USERNAME}`} className="fa fa-instagram"></Link></li>
									</ul>
							   </div> 
						</div>
					</div>                                      
				</div>
			</div>																						  
		))}				
	</OwlCarousel> 	
	:null}	  	
	{/* <!-- GALLERY SECTION END --> */}	
	
	
    </>	
    )
}
OwlCarouselElementsSliders.defaultProps = {
   type:'FadeSlider',   
};
export default OwlCarouselElementsSliders;